// HelpInfoMixin.ts

import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AppHostnameMixin } from './AppHostnameMixin';
import { AthleteRoutingMixin } from './AthleteRoutingMixin';

@Component
export class HelpInfoMixin extends Mixins(AppHostnameMixin, AthleteRoutingMixin) {
    @Prop({type: Boolean}) value;
	@Prop({ type: Boolean }) showHelp;

    get ShowHelp() {
        if( !this.AthleteAppActive ) return false;
        return this.value;
    }

    async onToggleHelp() {
        await this.$emit('input', this.value);
        await this.$emit('toggle');
    }
	async onHideHelp() {
		await this.$emit('hideHelp');
	}
    async onEditProfile() {
        await this.gotoAthleteSettings();
        await this.$emit('edit');
    }
}